import { axiosInstance } from '.';
const getProvidersOutstanding = async (params) => await axiosInstance.get('/service_providers/outstanding_balances',{ params })
const getTransactionsList = async (params) => await axiosInstance.get('/payment_transactions/unsettled_payment_transactions',{ params });
const getSettlementsList = async (params) => await axiosInstance.get('/settlements',{ params });
const createSettlement = async (data) => await axiosInstance.post('/settlements', data );
const exportSettlements = async (params) => await axiosInstance.get('/settlements/generate_report', { params });
const getFixedCommissionFees = async (params) => await axiosInstance.get('/fixed_fees_charges',{ params });

export {
    getProvidersOutstanding,
    getTransactionsList,
    getSettlementsList,
    createSettlement,
    getFixedCommissionFees,
    exportSettlements
}